// removed by extract-text-webpack-plugin
module.exports = {"cancel-processing-container":"cancel-processing-modal__cancel-processing-container___wy1zA","cancel-processing-content":"cancel-processing-modal__cancel-processing-content___sboEd","button-group":"cancel-processing-modal__button-group___t44bN","small":"cancel-processing-modal__small___2lyQb"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/cancel-processing-modal.scss
// module id = 1369
// module chunks = 0